export default __webpack_public_path__ + "static/media/ic_youtube.8f8ab40e.svg";